// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25K_h","colBig":"styles_colBig__2zNz3","colSmall":"styles_colSmall__1FJo8"};